import {Component, Inject} from 'ng-metadata/core';
import {MediaQueries} from '../../infra/mediaQueries.service';

@Component({
    selector: 'prm-icp-license-footer',
    templateUrl: 'components/primoExplore/footers/icp-license-footer.html'
})

export class PrimoIcpLicenseFooter {

    constructor(private mediaQueries: MediaQueries) {

    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/footers/icpLicenseFooter.directive.ts